import matches from 'lodash/matches';

export type ValidatedMap = Record<string | number, string>;
export type ValidationResult<K> = (K & { error: string }) | null;
export type RuleFn<T, K> = (_validationTarget: T) => K[];

export const validationMap =
    <T, K>(rules: RuleFn<T, K>) =>
    (target: T) => {
        return rules(target).filter(Boolean);
    };

export const locateError =
    <K>(validationResults: K[]) =>
    (matcher: Partial<K>) =>
        validationResults.find(matches(matcher));
